import type { IconProps } from './types';

export const TableIcon: React.FC<IconProps> = ({
  className,
  width = '16px',
  height = '16px',
  color = 'currentColor',
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icons/table">
      <path
        id="vector"
        d="M1.66663 6.66663L18.3333 6.66663M6.66663 6.66663V18.3333M18.3333 4.99996V15C18.3333 16.8409 16.8409 18.3333 15 18.3333H4.99996C3.15901 18.3333 1.66663 16.8409 1.66663 15L1.66663 4.99996C1.66663 3.15901 3.15901 1.66663 4.99996 1.66663L15 1.66663C16.8409 1.66663 18.3333 3.15901 18.3333 4.99996Z"
        stroke={color}
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
